// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl

const getNewsListAsync = ({ classId, page }: any) => {
  return http.get('vote/public/controller.php?enews=news-list', {
    params: {
      classId,
      page,
    },
  });
};

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

export { getNewsListAsync, getNews };
